import { Checkbox } from '@mui/material';

// import { useSettings } from 'app/main/components';

import type { ItemSelectionEvent } from '../hooks/useSelection';

interface SelectAllItemsCheckboxProps {
	selectedItems?: any[];
}

export default function SelectAllItemsCheckbox({ selectedItems }: SelectAllItemsCheckboxProps) {
	return (
		<Checkbox
			indeterminate={(selectedItems?.length || 0) > 0}
			onClick={() => {
				const event: ItemSelectionEvent = new CustomEvent('handleAllItemsSelection');
				document.dispatchEvent(event);
			}}
		/>
	);
}
